import { useTrans } from "@/translations";

import { useMemo, useState } from "react";

import { RecyclingRateTrendGraph } from "./components/graph";
import { RecyclingRateOptions } from "./components/options";
import { type ViewType } from "./constants";
import { RecyclingRateTrendContext } from "./context";
import { ChartType, RecyclingRatePoint } from "./types";

type Props = {
  data: RecyclingRatePoint[];
  subtitle: string;
  viewType: ViewType;
  target: number;
  updateTarget: (value: number) => void;
  showCompareYear: boolean;
  setShowCompareYear: (value: boolean) => void;
  showPortfolioAverage?: boolean;
  setShowPortfolioAverage?: (value: boolean) => void;
};

export const RecyclingRate: React.FC<Props> = ({
  data,
  subtitle,
  viewType,
  target,
  updateTarget,
  showCompareYear,
  setShowCompareYear,
  showPortfolioAverage = false,
  setShowPortfolioAverage = () => {},
}) => {
  const { t } = useTrans();
  const [chartType, setChartType] = useState<ChartType>(ChartType.LINE);

  const [showTarget, setShowTarget] = useState(true);

  const contextValue = useMemo(
    () => ({
      chartType,
      setChartType,
      target,
      updateTarget,
      showTarget,
      setShowTarget,
      showCompareYear,
      setShowCompareYear,
      showPortfolioAverage,
      setShowPortfolioAverage,
      viewType,
    }),
    [
      chartType,
      target,
      updateTarget,
      showTarget,
      showCompareYear,
      setShowCompareYear,
      showPortfolioAverage,
      setShowPortfolioAverage,
      viewType,
    ],
  );

  return (
    <RecyclingRateTrendContext.Provider value={contextValue}>
      <div className="flex flex-col">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div>
            <h3 className="font-dm-sans text-[14px] font-bold">
              {t("homePage:recyclingRateTitle")}
            </h3>
            <p className="text-grey6 font-dm-sans mt-[3px] text-[12.5px]">
              {subtitle}
            </p>
          </div>

          <RecyclingRateOptions />
        </div>

        <div className="mt-3 h-[247.5px] w-full">
          <RecyclingRateTrendGraph data={data} />
        </div>
      </div>
    </RecyclingRateTrendContext.Provider>
  );
};
